import { useEffect, useState } from 'react';
import api from '../services/api';
import { runConfetti, webConfettiEvent, webShutdownEvent, webWarningEvent } from './confetti';
import TechnicalIssues from './TechnicalIssues';
import WarningBanner from './WarningBanner';
import './ConfettiEvent.css';

const ConfettiEvent = ({ blockShutdown = false }) => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const response = await api.get('/events/active');
        if (cancelled) return;
        setEvents(Array.isArray(response.data?.events) ? response.data.events : []);
      } catch {
        // A failed check keeps the page that is already on screen.
      }
    };

    check();
    const interval = setInterval(check, 12000);
    window.addEventListener('app-events-changed', check);
    window.addEventListener('focus', check);

    return () => {
      cancelled = true;
      clearInterval(interval);
      window.removeEventListener('app-events-changed', check);
      window.removeEventListener('focus', check);
    };
  }, []);

  const shutdown = blockShutdown ? null : webShutdownEvent(events);
  const warning = shutdown ? null : webWarningEvent(events);
  const confettiId = shutdown || warning ? null : (webConfettiEvent(events)?.id || null);

  useEffect(() => {
    if (!shutdown) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [shutdown]);

  useEffect(() => {
    if (!confettiId) return undefined;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const canvas = document.createElement('canvas');
    canvas.className = 'confetti-overlay';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    const stop = runConfetti(canvas);
    return () => {
      stop();
      canvas.remove();
    };
  }, [confettiId]);

  if (!shutdown && !warning) return null;
  return (
    <>
      {shutdown ? <TechnicalIssues event={shutdown} /> : null}
      {warning ? <WarningBanner event={warning} /> : null}
    </>
  );
};

export default ConfettiEvent;
